import { render, staticRenderFns } from "./ShowDealers.vue?vue&type=template&id=1efb1a98&scoped=true&"
import script from "./ShowDealers.vue?vue&type=script&lang=js&"
export * from "./ShowDealers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb1a98",
  null
  
)

export default component.exports